import React from 'react';
import { useScreenInit } from './useScreenInit';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { WhyItDidntWork } from './components/WhyItDidntWork';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoItsFor } from './components/WhoItsFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
import { SectionDivider } from './components/ui/SectionDivider';
export function App() {
  useScreenInit();
  return <div className="min-h-screen bg-midnight text-bone font-body selection:bg-cyan-signal/30 selection:text-bone" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SectionDivider data-id="element-4" />
      <WhyItDidntWork data-id="element-5" />
      <UniqueMechanism data-id="element-6" />
      <WhatYouGet data-id="element-7" />
      <WhoItsFor data-id="element-8" />
      <HowItWorks data-id="element-9" />
      <ProofSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <OfferBlock data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}